// extracted by mini-css-extract-plugin
export default {"footer":"FooterComponent_footer__cIqa1"};